import React, { useEffect, useMemo } from 'react';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { formatMetricDataForChart } from '../../utils/format';
import { ChartWrapper } from '../styled';

function SPITrend({ data = [], metricKey }) {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const chartOption = useMemo(
    () => formatMetricDataForChart({ chartData: data, metricKey }),
    [data, metricKey],
  );

  useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  return (
    <ChartWrapper>
      <BaseChart
        chartId="widget-spi-trend"
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: 70, width: '100%' }}
      />
    </ChartWrapper>
  );
}

export default SPITrend;
